// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-section {
    border-bottom: 1px solid rgba(17, 17, 17, 0.08);
}

.filter-section__header {
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    font-size: 15px;
    justify-content: space-between;
    padding: 18px 0;
    width: 100%;
}

.filter-section__arrow {
    transition: transform 0.25s ease;
}

.filter-section__arrow.open {
    transform: rotate(180deg);
}

.filter-section__content {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.22s ease;
}

.filter-section__content.open {
    grid-template-rows: 1fr;
}

.filter-section__content-inner {
    min-height: 0;
    overflow: hidden;
}

.filter-section__content.open .filter-section__content-inner {
    padding-bottom: 18px;
}

.filter-section__content label {
    align-items: center;
    color: #5f5a54;
    display: flex;
    gap: 8px;
    margin-top: 10px;
}

.catalog-filter-option {
    justify-content: space-between;
}

.catalog-filter-option input {
    flex: 0 0 auto;
}

.catalog-filter-option__label {
    flex: 1;
}

.catalog-filter-option__count {
    color: #9a948c;
    font-size: 12px;
}

.catalog-filter-price {
    display: grid;
    gap: 10px;
    grid-template-columns: 1fr 1fr;
}

.catalog-filter-price input {
    border: 1px solid rgba(17, 17, 17, 0.16);
    border-radius: 0;
    min-height: 38px;
    min-width: 0;
    padding: 0 10px;
}

.catalog-filter-button {
    align-items: center;
    background: #ffffff;
    border: 1px solid #111111;
    border-radius: 0;
    color: #111111;
    cursor: pointer;
    display: inline-flex;
    font-size: 12px;
    font-weight: 700;
    gap: 8px;
    letter-spacing: 0.08em;
    min-height: 40px;
    padding: 0 16px;
    text-transform: uppercase;
    transition: background-color 0.2s ease, color 0.2s ease;
}

.catalog-filter-button:hover {
    background: #111111;
    color: #ffffff;
}

.catalog-filter-sort {
    display: grid;
    gap: 2px;
}

.catalog-filter-sort__option {
    cursor: pointer;
    justify-content: flex-start !important;
    min-height: 36px;
}

.catalog-filter-sort__option input {
    appearance: none;
    border: 1px solid #77736e;
    border-radius: 50%;
    height: 15px;
    margin: 0 2px 0 0;
    position: relative;
    width: 15px;
}

.catalog-filter-sort__option input:checked::after {
    background: #171717;
    border-radius: 50%;
    content: '';
    inset: 3px;
    position: absolute;
}

.catalog-filter-sort__option span {
    color: #2f2d2a;
    font-size: 14px;
}

.catalog-filter-button__count {
    align-items: center;
    background: #111111;
    color: #ffffff;
    display: inline-flex;
    font-size: 10px;
    height: 20px;
    justify-content: center;
    min-width: 20px;
    padding: 0 5px;
}

.catalog-filter-button:hover .catalog-filter-button__count {
    background: #ffffff;
    color: #111111;
}

.catalog-filter-overlay {
    animation: catalog-filter-overlay-in .2s ease both;
    background: rgba(17, 17, 17, 0.38);
    inset: 0;
    position: fixed;
    z-index: 40;
}

@keyframes catalog-filter-overlay-in { from { opacity: 0; } to { opacity: 1; } }

.catalog-filter {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    height: 100dvh;
    left: 0;
    max-width: 400px;
    position: fixed;
    top: 0;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    will-change: transform;
    width: 100%;
    z-index: 50;
}

.catalog-filter.open {
    transform: translateX(0);
}

.catalog-filter__header {
    align-items: center;
    border-bottom: 1px solid rgba(17, 17, 17, 0.08);
    display: flex;
    justify-content: space-between;
    padding: 24px 24px 18px;
}

.catalog-filter__header h2 {
    font-size: 18px;
    font-weight: 500;
    margin: 0;
}

.catalog-filter__close {
    align-items: center;
    background: none;
    border: 1px solid rgba(17, 17, 17, 0.12);
    border-radius: 0;
    cursor: pointer;
    display: inline-flex;
    height: 36px;
    justify-content: center;
    width: 36px;
}

.catalog-filter__content {
    flex: 1;
    overflow-y: auto;
    padding: 0 24px 110px;
}

.catalog-filter__bottom {
    align-items: center;
    background: #ffffff;
    border-top: 1px solid rgba(17, 17, 17, 0.08);
    bottom: 0;
    display: flex;
    gap: 14px;
    left: 0;
    padding: 18px 24px 24px;
    position: absolute;
    right: 0;
}

.catalog-filter__clear {
    background: none;
    border: none;
    color: #5f5a54;
    cursor: pointer;
    font-size: 14px;
    padding: 0;
    text-decoration: underline;
}

.catalog-filter__apply {
    background: #111111;
    border: 1px solid #111111;
    border-radius: 0;
    color: #ffffff;
    cursor: pointer;
    flex: 1;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.14em;
    min-height: 48px;
    text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/components/Catalog/CatalogFilter.css"],"names":[],"mappings":"AAAA;IACI,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,uDAAuD;AAC3D;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kDAAkD;IAClD,kCAAkC;IAClC,QAAQ;IACR,eAAe;IACf,WAAW;AACf;;AAEA,uCAAuC,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAE/E;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,OAAO;IACP,gBAAgB;IAChB,eAAe;IACf,MAAM;IACN,4BAA4B;IAC5B,+BAA+B;IAC/B,sBAAsB;IACtB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,+CAA+C;IAC/C,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,wCAAwC;IACxC,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,4CAA4C;IAC5C,SAAS;IACT,aAAa;IACb,SAAS;IACT,OAAO;IACP,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,OAAO;IACP,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;AAC7B","sourcesContent":[".filter-section {\n    border-bottom: 1px solid rgba(17, 17, 17, 0.08);\n}\n\n.filter-section__header {\n    align-items: center;\n    background: none;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    font-size: 15px;\n    justify-content: space-between;\n    padding: 18px 0;\n    width: 100%;\n}\n\n.filter-section__arrow {\n    transition: transform 0.25s ease;\n}\n\n.filter-section__arrow.open {\n    transform: rotate(180deg);\n}\n\n.filter-section__content {\n    display: grid;\n    grid-template-rows: 0fr;\n    transition: grid-template-rows 0.22s ease;\n}\n\n.filter-section__content.open {\n    grid-template-rows: 1fr;\n}\n\n.filter-section__content-inner {\n    min-height: 0;\n    overflow: hidden;\n}\n\n.filter-section__content.open .filter-section__content-inner {\n    padding-bottom: 18px;\n}\n\n.filter-section__content label {\n    align-items: center;\n    color: #5f5a54;\n    display: flex;\n    gap: 8px;\n    margin-top: 10px;\n}\n\n.catalog-filter-option {\n    justify-content: space-between;\n}\n\n.catalog-filter-option input {\n    flex: 0 0 auto;\n}\n\n.catalog-filter-option__label {\n    flex: 1;\n}\n\n.catalog-filter-option__count {\n    color: #9a948c;\n    font-size: 12px;\n}\n\n.catalog-filter-price {\n    display: grid;\n    gap: 10px;\n    grid-template-columns: 1fr 1fr;\n}\n\n.catalog-filter-price input {\n    border: 1px solid rgba(17, 17, 17, 0.16);\n    border-radius: 0;\n    min-height: 38px;\n    min-width: 0;\n    padding: 0 10px;\n}\n\n.catalog-filter-button {\n    align-items: center;\n    background: #ffffff;\n    border: 1px solid #111111;\n    border-radius: 0;\n    color: #111111;\n    cursor: pointer;\n    display: inline-flex;\n    font-size: 12px;\n    font-weight: 700;\n    gap: 8px;\n    letter-spacing: 0.08em;\n    min-height: 40px;\n    padding: 0 16px;\n    text-transform: uppercase;\n    transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.catalog-filter-button:hover {\n    background: #111111;\n    color: #ffffff;\n}\n\n.catalog-filter-sort {\n    display: grid;\n    gap: 2px;\n}\n\n.catalog-filter-sort__option {\n    cursor: pointer;\n    justify-content: flex-start !important;\n    min-height: 36px;\n}\n\n.catalog-filter-sort__option input {\n    appearance: none;\n    border: 1px solid #77736e;\n    border-radius: 50%;\n    height: 15px;\n    margin: 0 2px 0 0;\n    position: relative;\n    width: 15px;\n}\n\n.catalog-filter-sort__option input:checked::after {\n    background: #171717;\n    border-radius: 50%;\n    content: '';\n    inset: 3px;\n    position: absolute;\n}\n\n.catalog-filter-sort__option span {\n    color: #2f2d2a;\n    font-size: 14px;\n}\n\n.catalog-filter-button__count {\n    align-items: center;\n    background: #111111;\n    color: #ffffff;\n    display: inline-flex;\n    font-size: 10px;\n    height: 20px;\n    justify-content: center;\n    min-width: 20px;\n    padding: 0 5px;\n}\n\n.catalog-filter-button:hover .catalog-filter-button__count {\n    background: #ffffff;\n    color: #111111;\n}\n\n.catalog-filter-overlay {\n    animation: catalog-filter-overlay-in .2s ease both;\n    background: rgba(17, 17, 17, 0.38);\n    inset: 0;\n    position: fixed;\n    z-index: 40;\n}\n\n@keyframes catalog-filter-overlay-in { from { opacity: 0; } to { opacity: 1; } }\n\n.catalog-filter {\n    background: #ffffff;\n    display: flex;\n    flex-direction: column;\n    height: 100dvh;\n    left: 0;\n    max-width: 400px;\n    position: fixed;\n    top: 0;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease;\n    will-change: transform;\n    width: 100%;\n    z-index: 50;\n}\n\n.catalog-filter.open {\n    transform: translateX(0);\n}\n\n.catalog-filter__header {\n    align-items: center;\n    border-bottom: 1px solid rgba(17, 17, 17, 0.08);\n    display: flex;\n    justify-content: space-between;\n    padding: 24px 24px 18px;\n}\n\n.catalog-filter__header h2 {\n    font-size: 18px;\n    font-weight: 500;\n    margin: 0;\n}\n\n.catalog-filter__close {\n    align-items: center;\n    background: none;\n    border: 1px solid rgba(17, 17, 17, 0.12);\n    border-radius: 0;\n    cursor: pointer;\n    display: inline-flex;\n    height: 36px;\n    justify-content: center;\n    width: 36px;\n}\n\n.catalog-filter__content {\n    flex: 1;\n    overflow-y: auto;\n    padding: 0 24px 110px;\n}\n\n.catalog-filter__bottom {\n    align-items: center;\n    background: #ffffff;\n    border-top: 1px solid rgba(17, 17, 17, 0.08);\n    bottom: 0;\n    display: flex;\n    gap: 14px;\n    left: 0;\n    padding: 18px 24px 24px;\n    position: absolute;\n    right: 0;\n}\n\n.catalog-filter__clear {\n    background: none;\n    border: none;\n    color: #5f5a54;\n    cursor: pointer;\n    font-size: 14px;\n    padding: 0;\n    text-decoration: underline;\n}\n\n.catalog-filter__apply {\n    background: #111111;\n    border: 1px solid #111111;\n    border-radius: 0;\n    color: #ffffff;\n    cursor: pointer;\n    flex: 1;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.14em;\n    min-height: 48px;\n    text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
